import { phaseLabel, phaseColor } from '../../utils/metricsFormat';

/**
 * Barras horizontais, uma por fase — usada tanto para o WIP do quadro
 * (contagem de cartões) quanto para a distribuição de tempo por fase do
 * cartão (duração). `items` já vem na ordem de exibição: o backend preenche
 * todas as fases, mesmo as zeradas (fillWip/fillPhases em metrics.routes.js);
 * este componente só formata e desenha.
 */
export default function PhaseBarChart({ items, formatValue, emptyLabel = '0' }) {
  const max = Math.max(1, ...items.map((i) => i.value || 0));
  return (
    <div className="space-y-2">
      {items.map((item) => {
        const color = phaseColor(item.phase);
        const pct = item.value > 0 ? Math.max(3, (item.value / max) * 100) : 0;
        return (
          <div key={item.phase} className="flex items-center gap-2.5">
            <div className="w-[92px] shrink-0 text-[12px] text-text-secondary truncate" title={phaseLabel(item.phase)}>
              {phaseLabel(item.phase)}
            </div>
            <div className="flex-1 h-5 bg-white/5 rounded overflow-hidden">
              <div className={`h-full rounded ${color.bg}`} style={{ width: `${pct}%` }} />
            </div>
            <div className="w-16 shrink-0 text-right text-[12px] text-text-primary font-medium tabular-nums">
              {item.value > 0 ? formatValue(item.value) : emptyLabel}
            </div>
          </div>
        );
      })}
    </div>
  );
}
